import {Component} from '@angular/core';
import {FieldType} from '@ngx-formly/core';

@Component({
  selector: 'formly-field-input',
  template: ` <div [ngSwitch]="props?.type">
    <input
      *ngSwitchCase="'decimal'"
      currencyMask
      [tooltip]="props?.tooltip"
      class="form-control"
      [formControl]="formControl"
      [formlyAttributes]="field"
    />
    <input
      *ngSwitchDefault
      [tooltip]="props?.tooltip"
      class="form-control"
      [type]="props?.type"
      [formControl]="formControl"
      [formlyAttributes]="field"
    />
    <div *ngIf="to?.fourEyesValue!=null" class="arrow-wrapper">
      <div class="arrow"></div>
        <div [ngSwitch]="props?.type">
          <input
            *ngSwitchCase="'decimal'"
            currencyMask
            [tooltip]="props?.tooltip"
            class="form-control foureyes"
            [formlyAttributes]="field"
            [value]="props?.fourEyesValue"
          />
          <input
            *ngSwitchDefault
            [tooltip]="props?.tooltip"
            class="form-control foureyes"
            [type]="props?.type"
            [formlyAttributes]="field"
            [value]="props?.fourEyesValue"
          />
        </div>
    </div>
  </div>`,
})
export class FormlyFieldInput extends FieldType {}
